import { Text, View, styled } from 'tamagui';

export const Content = styled(Text, {
  fs: 16,
  mt: 3,
});
